import React from "react";
import Select from "react-select";
import { useState, useEffect } from "react";
const AffectedItem = React.forwardRef((props, ref) => {
  const [componentstatus, setComponentstatus] = useState(false);
  const [componentval, setComponentval] = useState("");
  const [statusval, setStatusval] = useState("");
  const [defaultval, setDefaultval] = useState("");
  let checked = false;
  let optionValue = "";
  let optionId = "";

  function onStatusHandler(e) {
    setStatusval(componentval + "," + e.value);
    componentarr.push(componentval + "," + e.value);
  }

  function onChangeHandler(e) {
    setComponentstatus(e.target.checked);
    setComponentval(e.target.id);
  }
  const {
    containerCls = "",
    inputProps = {},
    label,
    name,
    record,
    options,
    componentarr,
    primaryLabel,
    error,
    baseinfo,
    formInput,
    defaultValue,
  } = props;

  defaultValue?.map((items) => {
    items?.map((item) => {
      if (item.component === record.value) {
        checked = true;
        optionValue = item.componentStatus.label;
        optionId = item.componentStatus._id;
      }
    });
  });

  return (
    <div className="grid grid-cols-3 gap-4">
      <div className="my-4" key={record.label}>
        <input
          {...inputProps}
          key={record.value}
          type="checkbox"
          name="affectedComponents"
          onChange={onChangeHandler}
          id={record.value}
          defaultChecked={checked}
          // value={statusval ? statusval : record.value + "," + optionId}
          value={componentarr}
        />
        <span className="pb-1 text-gray-800 incident_checkbox">
          {record.label}
        </span>
      </div>
      {(componentstatus || checked) && (
        <div key={record.value}>
          <Select
            options={options}
            onChange={onStatusHandler}
            defaultValue={options.filter(
              (option) => option.label === optionValue
            )}
          />
        </div>
      )}
      <div></div>
    </div>
  );
});
export default AffectedItem;
